import userFriendlyEr from '../../../utils/userFriendlyEr.js'
import {cadastr, tko} from '../../../api/api-endpoints.js'
import {cadastrOffline} from '../../../api/api-offline-endpoints'
import formBaseMixin from  '../../../components/form/form-base-mixin.js'
import {STATUS_NOT_ACTIVE} from '../../../config/config.js'
import {ACTIONS} from '../../../config/config.js'
import {Utilization, Processing} from '../../../config/config'

export default {
  mixins: [formBaseMixin],
  data () {
    return {
      fields: {
        name: '',
        tech_target_id: '',
        start_year: '',
        end_year: '',
        has_project: '',
        has_expertise: true,
        expertise_organization: '',
        expertise_date: '',
        actions: [],
        tkoOperatorName: '',
        tko_operator_id: ''
      }
    }
  },
  computed: {
    canUseGarbageProduction () {
      return this.fields.actions.indexOf(Utilization) > -1 || this.fields.actions.indexOf(Processing) > -1
    },
    ACTIONS () {
      return [
        ACTIONS.processing,
        ACTIONS.utilization,
        ACTIONS.neutralization
      ]
    },
    yeasOrNoBoolean () {
      return [
        {id: false, name: 'Нет'},
        {id: true, name: 'Есть'}
      ]
    },
    notActive () {
      return STATUS_NOT_ACTIVE
    },
    techTargets () {
      let tmp = this.$store.getters.readUrlEndpoint(this.getTechTargetsEndpoint()).tech_target.slice()
      tmp.push({
        id: -1, name: 'Иное'
      })
      return tmp
    },
    objects () {
      return [{id: 1, name: 'нет объектов'}]
    },
    years () {
      let years = []
      for (let i = 2013; i <= 2050; i++) {
        years.push({id: i, name: i})
      }
      return years
    }
  },
  methods: {
    onSelectOperator ($event) {
      if ($event && $event.id) {
        this.fields.tko_operator_id = $event.id
        this.fields.tkoOperatorName = $event.name
      } else {
        this.fields.tko_operator_id = null
        this.fields.tkoOperatorName = ''
      }
      console.log($event)
    },
    suggestionOperatorEndpoint (ctx, q) {
      return tko.regionalOperators({query: {q: q, 'per-page': 50}})
    },
    transformOperatorSuggestions (ctx, response) {
      let data = response.data
      let options = []
      for (let i = 0; i < data.length; i++) {
        options.push({
          name: data[i].name,
          id: data[i].id
        })
      }
      return options
    },
    initFieldsAfterLoad() {
      if (this.item) {
        this.fields = Object.assign({}, this.item)
        if (!this.fields.actions) {
          this.fields.actions = []
        }
        if (this.fields.tko_operator) {
          this.fields.tkoOperatorName = this.fields.tko_operator.name
        }
      }
    },
    additionalValidate: async function (hasError = false, errors = {}) {
      if (!this.fields.actions) {
        this.fields.actions = []
      }
      if (this.fields.actions.length < 1) {
        hasError = true
        errors['actions'] = 'Укажите вид деятельности'
        this.formValidator.handleServerErrors({data: {errors: errors}}, this)
      }

      if (!hasError) {
        return Promise.resolve(1)
      }
      return Promise.reject(1)
    },
    getEditablesEndpointsAndUrl () {
      let postUrl = []
      let tmpEndpoints = []

      let operations = ['input-fkko', 'output-fkko']
      if (this.canUseGarbageProduction) {
        operations.push('production')
      }
      for (let j = 0; j < operations.length; j++) {
        postUrl.push(cadastr.techGarbageOperationPost({
          query: {
            sourceId: this.fields.id,
            type: operations[j]
          }
        }))
        tmpEndpoints.push(cadastrOffline.techGarbageOperationTable(this.$route.name, operations[j]))
      }

      return {postUrl: postUrl, tmpEndpoints: tmpEndpoints}
    },
    afterSave: async function () {
      let errors = []

      if (!this.$route.params.id) {
        // save tech table for new records
        let {postUrl, tmpEndpoints} = this.getEditablesEndpointsAndUrl()

        for (let i = 0; i < tmpEndpoints.length; i++) {
          if (this.$store.getters.readUrlEndpoint(tmpEndpoints[i])) {
            let data = this.$store.getters.readUrlEndpoint(tmpEndpoints[i]).data
            for (let j = 0; j < data.length; j++) {
              data[j].tech_id = this.fields.id
              if (data[j]._isValid === true && data[j]._considerSaved === true) {
                try {
                  await this.$store.dispatch('createModel', {
                    url: postUrl[i],
                    endpoint: tmpEndpoints[i],
                    data: data[j]
                  })
                } catch (e) {
                  console.log(e)
                  errors.push('Отходы: ' + userFriendlyEr.recognize(e))
                }
              } else {
                console.warn('Invalid row', data[j])
              }
            }
          }
        }
      }

      if (errors.length > 0) {
        console.log(errors)
        return Promise.reject(errors.join('<br><br>'))
      }

      return Promise.resolve(1)
    }
  },
  asyncData ({store, route, fromRoute, methods}) {
    let promises = []
    if (methods.getItemEndpoint(route, fromRoute) !== null) {
      promises.push(store.dispatch('updateUrlEndpoint', {endpoint: methods.getItemEndpoint(route, fromRoute)}))
    }

    if (methods.getTechTargetsEndpoint) {
      promises.push(store.dispatch('updateUrlEndpoint', {
        fromCache: true,
        endpoint: methods.getTechTargetsEndpoint()
      }))
    }

    if (promises.length === 0) {
      return Promise.resolve(1)
    }

    return Promise.all(promises)
  }
}
